import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHyperledgerComponent } from './simple-icons-hyperledger.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHyperledgerComponent ],
    exports:      [ SimpleIconsHyperledgerComponent ],
    bootstrap:    []
})
export class SimpleIconsHyperledgerModule {}
